import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { DurationModel } from '../primitive/duration.model';
import { TextModel } from '../primitive/text.model';
import { CompositeModel } from './composite.model';

export class TimeZoneModel extends CompositeModel {
    public utcDiff: DurationModel;
    public utcSign: TextModel;
    public timeZone: TextModel;

    /**
     * Construct a timezone model either for the local time or for the supplied parameters
     *
     * @param utcDiff difference in minutes
     * @param utcSign is the difference positive or negative compared to GMT?
     * @param timeZone string to identify timezone
     */
    public constructor(utcDiff?: moment.Duration, utcSign?: '+' | '-', timeZone?: string) {
        super('TimeZoneModel');

        this.utcDiff = <DurationModel>(
            this.set(new DurationModel('UTCDiff', utcDiff || moment.duration(moment().utcOffset(), 'minutes')))
        );
        this.utcSign = <TextModel>this.set(new TextModel('UTCSign', utcSign || moment().utcOffset() >= 0 ? '+' : '-'));
        this.timeZone = <TextModel>this.set(new TextModel('TimeZone', timeZone || ''));
    }

    public getOutModel(): ODataTimeZoneOutModel {
        return <ODataTimeZoneOutModel>super.getOutModel();
    }
}

export interface ODataTimeZoneOutModel extends ODataObject {
    TimeZone: string;
    UTCSign: string;
    UTCDiff: string;
}
